import React, { useEffect, useState } from "react";
import DecorativeSquares from "../../components/ui/DecorativeSquares";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import { useDispatch } from "react-redux";
import { getCustomerMealPlan } from "../../redux/thunks/deiverAnorderThunk";
import orderdish from "../../assets/images/svgs/cards/orders.svg";
import PrimaryBtn from "../../components/button/PrimaryBtn";
import { getCustomerRecords } from "../../redux/thunks/customerRecordThunk";
import { GoMoon, GoSun } from "react-icons/go";
import DeliveryIcon from "../../assets/images/svgs/cards/delivery.svg";
import ImagePreview from "../../components/ui/ImagePreview";
import { CiLocationOn } from "react-icons/ci";
import { FaArrowLeft } from "react-icons/fa";
import { decryptId } from "../../utils/urlCrypto";
import MapModal from "../../components/Modals/MapModal";
import { SquareArrowOutUpRight } from "lucide-react";

const Subscriptiondetails = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const { meal_plan_id: paramMealPlanId } = useParams();
  const meal_plan_id = decryptId(paramMealPlanId);
  const location = useLocation();
  const [mealdetail, setMealdetail] = useState({});
  const [Currency, setCurrency] = useState("");
  const [isMapOpen, setIsMapOpen] = useState(false);
  const customer_id = location.state?.customerId;
  const handleGoBack = () => {
    navigate(-1);
  };

  const WEEK_DAYS = [
    { id: 1, label: "M", name: "Monday" },
    { id: 2, label: "Tu", name: "Tuesday" },
    { id: 3, label: "W", name: "Wednesday" },
    { id: 4, label: "Th", name: "Thursday" },
    { id: 5, label: "F", name: "Friday" },
    { id: 6, label: "Sa", name: "Saturday" },
    { id: 7, label: "Su", name: "Sunday" },
  ];

  useEffect(() => {
    const payload = {
      sp_customer_meal_plan_id: meal_plan_id,
    };
    dispatch(getCustomerMealPlan(payload))
      .unwrap()
      .then((res) => {
        // console.log("The res of getting meal plan detail is :", res.data);

        const getAllDetails = res.data;
        setMealdetail(getAllDetails);

        // console.log("The details is :", getAllDetails);
        // console.log("The descripton is :", res.data?.meal_id);
      });
  }, [meal_plan_id, dispatch]);

  useEffect(() => {
    // console.log("The customer id is :", customer_id);
  }, [customer_id]);

  // get customer details
  useEffect(() => {
    const payload = {
      service_provider_customer_id: customer_id,
    };
    // console.log("The custmr id is :", customer_id);
    dispatch(getCustomerRecords(payload))
      .unwrap()
      .then((res) => {
        // console.log("The res of getting customers record is :", res.data);
        setCurrency(res.data?.currency_symbol);
      });
  }, [dispatch]);
  return (
    <>
      <section className="space-y-6  max-w-7xl mx-auto relative max-h-screen">
        <DecorativeSquares />
        <div className="sticky top-2 z-10 bg-white/80 backdrop-blur-md rounded-2xl shadow-md px-4 py-3 flex items-center justify-between mb-6">
          <button
            onClick={handleGoBack}
            className="flex items-center p-2 rounded-full hover:bg-gray-100"
          >
            <FaArrowLeft size={20} />
          </button>

          <h1 className="mx-auto text-2xl font-semibold text-gray-900">
            Subscription plan detail
          </h1>
        </div>

        <div className="  mt-8">
          <div className="mx-auto w-full max-w-7xl bg-white border border-gray-200 rounded-xl p-6 shadow-sm">
            <div className="flex items-center gap-4">
              {/* Avatar */}
              <div className="flex items-center justify-center  rounded-md bg-[#FFEFEB] text-[#FF6943] font-semibold">
                <ImagePreview
                  src={mealdetail?.meal?.meal_image}
                  alt={mealdetail?.meal?.meal_name}
                  className="object-cover w-12 h-12 rounded-md"
                />
              </div>

              {/* User Info */}
              <div className="flex flex-col">
                <h2 className="text-base font-semibold text-gray-900">
                  {mealdetail?.meal?.meal_name}
                </h2>

                <div className="flex start gap-4 ">
                  <p className="mt-1 flex items-center gap-2 text-sm   font-bold">
                    <img src={orderdish} alt="orderDish" className="w-4 h-4" />{" "}
                    x {mealdetail?.single_order_meal_quantity}
                  </p>
                  <p className="mt-1 flex items-center gap-2 text-sm text-[#FF6943] font-bold">
                    {Currency}
                    {Number(mealdetail?.single_order_base_amounts).toFixed(2)}
                  </p>
                </div>
              </div>
            </div>

            <div className="border-b border-gray-200 mt-6 mb-2"></div>

            <div className="mt-4">
              {/* Order details */}
              <div className="relative -mx-4 sm:mx-0 overflow-x-auto lg:overflow-x-hidden mt-4">
                <div className=" w-full md:min-w-[640px] rounded-lg border border-gray-200 bg-white">
                  <table className="w-full text-left text-sm sm:text-base text-gray-800">
                    <thead className="bg-gray-50">
                      {mealdetail.extra_items?.length > 0 && (
                        <tr>
                          <th
                            colSpan={2}
                            className="py-3 px-4 text-start text-base sm:text-lg font-semibold"
                          >
                            Extra items
                          </th>
                          <th
                            colSpan={2}
                            className="py-3 px-4 text-end text-base sm:text-lg font-semibold text-[#FF6943]"
                          >
                            {Currency}
                            {Number(mealdetail.extra_items_total).toFixed(2)}
                          </th>
                        </tr>
                      )}
                    </thead>

                    <tbody className="divide-y">
                      {mealdetail.extra_items?.length > 0 &&
                        mealdetail.extra_items?.map((item, i) => (
                          <tr key={i}>
                            <td colSpan={2} className="py-2 px-4">
                              <div className="flex items-center gap-2 whitespace-nowrap">
                                <span className="inline-block w-2 h-2 rounded-full bg-[#FF6943]" />
                                <span>{`${item.quantity} x ${item.name}`}</span>
                              </div>
                            </td>
                            <td className="py-2 px-4 text-end font-semibold whitespace-nowrap">
                              {Currency}
                              {Number(item.amount).toFixed(2)}
                            </td>
                          </tr>
                        ))}

                      {/* Charges */}
                      {mealdetail?.delivery_preference === "delivery"}
                      <tr className="bg-gray-50">
                        <th colSpan={2} className="py-3 px-4 font-semibold">
                          Delivery charges
                        </th>
                        <th className="py-3 px-4 text-end font-semibold text-[#FF6943]">
                          {Currency}
                          {mealdetail?.delivery_charges}
                        </th>
                      </tr>

                      {(() => {
                        const rawValue = Number(
                          mealdetail?.single_order_discount_and_other_charges ||
                            0,
                        );
                        const isDiscount = rawValue < 0;

                        return (
                          <tr>
                            <th colSpan={2} className="py-3 px-4 font-semibold">
                              {isDiscount ? "Discount" : "Other Charges"}
                            </th>

                            <th
                              className={`py-3 px-4 text-end font-semibold ${
                                isDiscount ? "text-[#1CCB50]" : "text-red-500"
                              }`}
                            >
                              {isDiscount ? `- ${Currency}` : `+ ${Currency}`}
                              {Math.abs(rawValue).toFixed(2)}
                            </th>
                          </tr>
                        );
                      })()}
                      <tr className="bg-orange-50">
                        <th
                          colSpan={2}
                          className="py-3 px-4 font-semibold text-[#FF6943]"
                        >
                          Total Order Amount
                        </th>
                        <th className="py-3 px-4 text-end font-semibold text-[#FF6943]">
                          {Currency}
                          {Number(
                            mealdetail?.single_order_final_amounts,
                          ).toFixed(2)}
                        </th>
                      </tr>
                      <tr className="bg-orange-50">
                        <th
                          colSpan={2}
                          className="py-3 px-4 font-semibold text-[#FF6943]"
                        >
                          Subscription cost ({mealdetail?.order_count} Meals)
                        </th>
                        <th className="py-3 px-4 text-end font-semibold text-[#FF6943]">
                          {Currency}
                          {Number(mealdetail?.total_amount).toFixed(2)}
                        </th>
                      </tr>
                    </tbody>

                    <tfoot className="border-t bg-white">
                      <tr>
                        <th colSpan={2} className="py-3 px-4 font-medium">
                          Plan Type
                        </th>
                        <th
                          colSpan={2}
                          className="py-3 px-4 text-end font-semibold"
                        >
                          {mealdetail?.plan_type} ({mealdetail?.order_count}{" "}
                          Days)
                        </th>
                      </tr>
                      <tr>
                        <th colSpan={2} className="py-3 px-4 font-medium">
                          Start Date
                        </th>
                        <th
                          colSpan={2}
                          className="py-3 px-4 text-end font-semibold"
                        >
                          {mealdetail?.start_date}
                        </th>
                      </tr>
                      <tr>
                        <th colSpan={2} className="py-3 px-4 font-medium">
                          Meal Timing
                        </th>
                        <th
                          colSpan={2}
                          className="py-3 px-4 text-end font-semibold"
                        >
                          {mealdetail?.meal_timing && (
                            <div className="flex justify-end items-center gap-2">
                              {mealdetail.meal_timing.toLowerCase() ===
                              "lunch" ? (
                                <GoSun size={17} className="font-bold" />
                              ) : (
                                <GoMoon size={17} className="font-bold" />
                              )}

                              <span className="capitalize">
                                {mealdetail.meal_timing}
                              </span>
                            </div>
                          )}
                        </th>
                      </tr>
                      {mealdetail.plan_type === "monthly" && (
                        <tr>
                          <th colSpan={2} className="py-3 px-4 font-medium">
                            Deliver Days
                          </th>
                          <th
                            colSpan={2}
                            className="py-3 px-4 text-end font-semibold"
                          >
                            <div className="flex gap-2 justify-end ">
                              {WEEK_DAYS.map((day) => {
                                const isSelected =
                                  mealdetail?.delivery_days.includes(day.id);

                                return (
                                  <button
                                    key={day.id}
                                    type="button"
                                    className={`text-[10px] flex justify-center items-center rounded-md  w-5 h-5 
                                        ${
                                          isSelected
                                            ? "bg-[#FF6943] text-white"
                                            : "bg-gray-200 text-[#FF6943]"
                                        }`}
                                  >
                                    {day.label}
                                  </button>
                                );
                              })}
                            </div>
                          </th>
                        </tr>
                      )}
                      <tr>
                        <th colSpan={2} className="py-3 px-4 font-medium">
                          Delivery Type
                        </th>
                        <th
                          colSpan={2}
                          className="py-3 px-4 text-end font-semibold"
                        >
                          <div className="flex justify-end items-center gap-2">
                            <img
                              src={DeliveryIcon}
                              alt="delivery icon"
                              className="h-4 w-4 object-contain"
                            />

                            <span className="capitalize">
                              {mealdetail.delivery_preference === "delivery"
                                ? "Home Delivery"
                                : "Pick Up"}
                            </span>
                          </div>
                        </th>
                      </tr>
                    </tfoot>
                  </table>
                </div>
              </div>
            </div>
            <div className="mt-4 flex justify-start gap-2">
              {mealdetail.delivery_preference === "delivery" && (
                <div
                  onClick={() => setIsMapOpen(true)}
                  className="mt-4 flex justify-start items-center gap-2 cursor-pointer hover:text-blue-600 transition"
                >
                  <CiLocationOn size={20} className="text-[#FF6943]" />
                  <p className="text-start text-[#FF6943] text-[12px] md:text-sm">
                    {mealdetail.address.address_1}
                  </p>
                  <SquareArrowOutUpRight
                    size={15}
                    className="text-[#FF6943] text-end"
                  />
                </div>
              )}
            </div>
          </div>
        </div>
      </section>
      <MapModal
        isOpen={isMapOpen}
        onClose={() => setIsMapOpen(false)}
        address={mealdetail.address}
        actualAddress={mealdetail.address?.address_1}
      />
    </>
  );
};

export default Subscriptiondetails;
